import { Link } from "react-router-dom";

import withStyles from "@material-ui/core/styles/withStyles";
import React, { Component } from "react";
import { updateVehicle, createInspection } from "../../graphql/mutations";
import {
  listVehicleTypes,
  getVehicle,
  listVehicles
} from "../../graphql/queries";
import gql from "graphql-tag";
import uuid from "uuid";
import { API, graphqlOperation } from "aws-amplify";
import Select from "react-select";
import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Container,
  Row,
  Col,
  Label
} from "reactstrap";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { spinnerService } from "@chevtek/react-spinners";
import * as actionTypes from "../../redux/actions";

import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Storage } from "aws-amplify";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
class UpdateVehicle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      typeName: "",
      _typeName: {
        value: "",
        isValid: true,
        err: ""
      },
      createdAt: "",
      customerVehicleId: "",
      _customerVehicleId: {
        value: "",
        isValid: true,
        err: ""
      },
      Id: "",
      license: "",
      _license: {
        value: "",
        isValid: true,
        err: ""
      },
      locationLat: "",
      locationLong: "",
      make: "",
      _make: {
        value: "",
        isValid: true,
        err: ""
      },
      model: "",
      _model: {
        value: "",
        isValid: true,
        err: ""
      },
      updatedAt: "",
      vehicleCustomerId: "",
      vehicleYear: "",
      _vehicleYear: {
        value: "",
        isValid: true,
        err: ""
      },
      vIN: "",
      _vIN: {
        value: "",
        isValid: true,
        err: ""
      },
      selectedOptions: [],
      licensePic: null,
      mainPic: null,
      vInPic: null,
      deactivateBIT: false,
      deactivateDOT: false,
      registeredInspectionType: "",
      bitDueDate45: null,
      _bitDueDate45: {
        value: "",
        isValid: true,
        err: ""
      },
      bitDueDate90: null,
      _bitDueDate90: {
        value: "",
        isValid: true,
        err: ""
      },
      dotDueDate: null,
      _dotDueDate: {
        value: "",
        isValid: true,
        err: ""
      }
    };
  }
  handleClickOpen = e => {
    e.preventDefault();
    let {
      make,
      vIN,
      model,
      license,
      vehicleYear,
      specialInstructions
    } = this.state;

    this.setState({ open: true });
  };

  handleClose = e => {
    e.preventDefault();
    this.setState({ open: false });
    this.updateVehicle();
  };
  onTextChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };
  notify = msg => toast(msg);
  updateVehicle = async () => {
    let {
      typeName,
      customerVehicleId,
      Id,
      license,
      make,
      model,
      bitDueDate,
      vehicleYear,
      vIN,
      specialInstructions,
      vehicleStatus,
      mainPic,
      licensePic,
      vInPic,
      deactivateBIT,
      deactivateDOT,
      registeredInspectionType,
      bitDueDate45,
      bitDueDate90,
      dotDueDate,
      _typeName,
      _vehicleYear,
      _make,
      _model,
      _license,
      _customerVehicleId,
      _bitDueDate45,
      _bitDueDate90,
      _dotDueDate,
      _vIN
    } = this.state;

    if (
      _customerVehicleId.value === "" ||
      _customerVehicleId.value === null ||
      _customerVehicleId.value === undefined
    ) {
      this.submitCheck("_customerVehicleId", _customerVehicleId.value);
      document.getElementById("_customerVehicleId").focus();
      return;
    }
    if (
      _typeName.value === "" ||
      _typeName.value === null ||
      _typeName.value === undefined
    ) {
      this.submitCheck("_typeName", _typeName.value);
      document.getElementById("typeName").focus();
      return;
    }
    if (_vIN.value === "" || _vIN.value === null || _vIN.value === undefined) {
      this.submitCheck("_vIN", _vIN.value);
      document.getElementById("_vIN").focus();
      return;
    }
    if (registeredInspectionType === "FEDERAL") {
      if (
        (_dotDueDate.value === "" ||
          _dotDueDate.value === null ||
          _dotDueDate.value === undefined) &&
        !this.state.deactivateDOT
      ) {
        this.submitCheck("_dotDueDate", _dotDueDate.value);
        document.getElementById("_dotDueDate").focus();
        return;
      }
    } else if (registeredInspectionType === "BIT") {
      if (
        (_bitDueDate90.value === "" ||
          _bitDueDate90.value === null ||
          _bitDueDate90.value === undefined) &&
        !this.state.deactivateBIT
      ) {
        this.submitCheck("_bitDueDate90", _bitDueDate90.value);
        document.getElementById("_bitDueDate90").focus();
        return;
      }
    } else if (registeredInspectionType === "FEDERAL_BIT") {
      if (
        (_bitDueDate90.value === "" ||
          _bitDueDate90.value === null ||
          _bitDueDate90.value === undefined) &&
        !this.state.deactivateBIT
      ) {
        this.submitCheck("_bitDueDate90", _bitDueDate90.value);
        document.getElementById("_bitDueDate90").focus();
        return;
      }
      if (
        (_dotDueDate.value === "" ||
          _dotDueDate.value === null ||
          _dotDueDate.value === undefined) &&
        !this.state.deactivateDOT
      ) {
        this.submitCheck("_dotDueDate", _dotDueDate.value);
        document.getElementById("_dotDueDate").focus();
        return;
      }
    } else if (registeredInspectionType === "BUS_LIMOS") {
      if (
        (_bitDueDate45.value === "" ||
          _bitDueDate45.value === null ||
          _bitDueDate45.value === undefined) &&
        !this.state.deactivateBIT
      ) {
        this.submitCheck("_bitDueDate45", _bitDueDate45.value);
        document.getElementById("_bitDueDate45").focus();
        return;
      }
    }
    try {
      spinnerService.show("mySpinner");
      await this.uploadImage();
      (make = _make.value),
        (customerVehicleId = _customerVehicleId.value),
        (model = _model.value),
        (license = _license.value),
        (vehicleYear = _vehicleYear.value),
        (bitDueDate90 = _bitDueDate90.value),
        (bitDueDate45 = _bitDueDate45.value),
        (dotDueDate = _dotDueDate.value),
        (typeName = _typeName.value),
        (vIN = _vIN.value);
      this.setState({
        make: _make.value,
        customerVehicleId: _customerVehicleId.value,
        model: _model.value,
        license: _license.value,
        vehicleYear: _vehicleYear.value,
        bitDueDate90: _bitDueDate90.value,
        bitDueDate45: _bitDueDate45.value,
        dotDueDate: _dotDueDate.value,
        typeName: _typeName.value,
        vIN: _vIN.value
      });
      var input = {
        id: Id,
        customerVehicleId: customerVehicleId,
        vehicleVehicleTypeId: typeName.value,
        make: make,
        VIN: vIN,
        model: model,
        specialInstructions: specialInstructions,
        license: license,
        vehicleYear: vehicleYear,
        vehicleStatus
      };

      if (!new RegExp("[A-HJ-NPR-Z0-9]{17}").test(vIN)) {
        document.getElementById("_vIN").focus();
        spinnerService.hide("mySpinner");
        toast.error("Please insert Valid VIN.");
        return;
      }
      input.mainPic = mainPic;
      input.vinPic = vInPic;
      input.licensePic = licensePic;
      //
      if (deactivateBIT === true) input.deactivateBIT = true;
      else input.deactivateBIT = false;
      if (deactivateDOT === true) input.deactivateDOT = true;
      else input.deactivateDOT = false;
      if (input.mainPic) {
        delete input.mainPic.__typename;
      }
      if (input.vinPic) {
        delete input.vinPic.__typename;
      }
      if (input.licensePic) {
        delete input.licensePic.__typename;
      }
      let nextInspDueArray = [];
      if (registeredInspectionType === "FEDERAL" && !deactivateDOT) {
        nextInspDueArray.push({
          inspectionType: "DOT_ANNUAL_INSPECTION",
          nextDueDate: dotDueDate
        });
      } else if (registeredInspectionType === "BIT" && !deactivateBIT) {
        nextInspDueArray.push({
          inspectionType: "BIT_90DAY_INSPECTION",
          nextDueDate: bitDueDate90
        });
      } else if (registeredInspectionType === "FEDERAL_BIT") {
        if (!deactivateDOT) {
          nextInspDueArray.push({
            inspectionType: "DOT_ANNUAL_INSPECTION",
            nextDueDate: dotDueDate
          });
        }
        if (!deactivateBIT) {
          nextInspDueArray.push({
            inspectionType: "BIT_90DAY_INSPECTION",
            nextDueDate: bitDueDate90
          });
        }
      } else if (registeredInspectionType === "BUS_LIMOS" && !deactivateBIT) {
        nextInspDueArray.push({
          inspectionType: "BIT_45DAY_INSPECTION",
          nextDueDate: bitDueDate45
        });
      }

      if (nextInspDueArray.length > 0) {
        input.nextInspectionDue = nextInspDueArray;
      } else {
        input.nextInspectionDue = [];
      }
      var result = await API.graphql(
        graphqlOperation(updateVehicle, { input })
      );

      spinnerService.hide("mySpinner");

      // this.props.updateVehicle([
      //   input.id,
      //   input.customerVehicleId,
      //   input.make,
      //   input.model,
      //   input.VIN,
      //   input.vehicleStatus,
      //   "Details",
      //   "Edit",
      //   "Del"
      // ]);
      this.props.history.push("/company");
      toast.success("Vehicle Updated");
    } catch (e) {
      toast.error(e.message);
      spinnerService.hide("mySpinner");
    }
  };

  submitCheck = (id, value) => {
    let arr = ["_vIN", "typeName", "_vehicleYear", "_customerVehicleId"];
    let arr1 = ["_dotDueDate", "_bitDueDate90", "_bitDueDate45"];
    if (
      (value === "" || value === null || value === undefined) &&
      arr1.includes(id)
    ) {
      if (id === "_dotDueDate" && !this.state.deactivateDOT) {
        this.setState({
          _dotDueDate: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate90" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate90: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate45" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate45: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
    }
    if (
      (value === "" || value === null || value === undefined) &&
      !arr1.includes(id)
    ) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else if (value.length > 0) {
      if (!arr.includes(id) && !arr1.includes(id) && value.length < 4) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 4 Characters Are Reuired"
          }
        });
      } else if (id === "_vIN" && value.length < 17) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "VIN Must be 17 Characters Long"
          }
        });
      }
    }
    if (id === "react-select-2-input") {
      if (this.state.typeName === null || this.state.typeName === "") {
        this.setState({
          _typeName: {
            value: this.state.typeName,
            isValid: false,
            err: "Please Select A Vehicle Type"
          }
        });
      }
    }
  };
  runtimeCheck = event => {
    const { id, value } = event.target;
    let arr = ["_vIN", "typeName", "_vehicleYear", "_customerVehicleId"];
    let arr1 = ["_dotDueDate", "_bitDueDate90", "_bitDueDate45"];
    if (
      (value === "" || value === null || value === undefined) &&
      arr1.includes(id)
    ) {
      if (id === "_dotDueDate" && !this.state.deactivateDOT) {
        this.setState({
          _dotDueDate: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate90" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate90: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
      if (id === "_bitDueDate45" && !this.state.deactivateBIT) {
        this.setState({
          _bitDueDate45: {
            value,
            isValid: false,
            err: "This Field is Required"
          }
        });
      }
    }
    if (
      (value === "" || value === null || value === undefined) &&
      !arr1.includes(id)
    ) {
      this.setState({
        [id]: {
          value,
          isValid: false,
          err: "This Field is Required"
        }
      });
    } else if (value.length > 0) {
      if (!arr.includes(id) && !arr1.includes(id) && value.length < 4) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "Atleast 4 Characters Are Reuired"
          }
        });
      } else if (id === "_vIN" && value.length < 17) {
        this.setState({
          [id]: {
            value,
            isValid: false,
            err: "VIN Must be 17 Characters Long"
          }
        });
      }
    }
    if (id === "react-select-2-input") {
      if (this.state.typeName === null || this.state.typeName === "") {
        this.setState({
          _typeName: {
            value: this.state.typeName,
            isValid: false,
            err: "Please Select A Vehicle Type"
          }
        });
      }
    }
  };

  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("/company");
  };
  loadVehTypes = async () => {
    const { client } = this.props;
    //const { vehTypesList } = await API.graphql(graphqlOperation(listVehicleTypes));
    const vehTypesList = await client.query({
      query: gql(listVehicleTypes),
      fetchPolicy: `network-only`
    });
    const vehTypesArray = new Array();

    vehTypesList.data.listVehicleTypes.items.map(itm => {
      let vehType = {};
      vehType.value = itm.id;
      vehType.label = itm.vehicleType;
      vehTypesArray.push(vehType);
    });
    this.setState({ selectedOptions: vehTypesArray }); //=vehTypesArray.slice();
  };
  loadVehicle = async id => {
    spinnerService.show("mySpinner");
    // const { registeredInspectionType } = this.state;
    const { client, data } = this.props;
    // if (data.customer !== null || data.cutomer !== undefined) {
    //   this.setState({
    //     registeredInspectionType: data.customer.registeredInspectionType
    //   });
    // }
    const vehicle = await client.query({
      query: gql(getVehicle),
      fetchPolicy: `network-only`,
      variables: { id }
    });

    const insp = vehicle.data.getVehicle.nextInspectionDue;

    let deactivateBIT = false;
    if (vehicle.data.getVehicle.deactivateBIT !== undefined) {
      if (vehicle.data.getVehicle.deactivateBIT === true) deactivateBIT = true;
      else deactivateBIT = false;
    }
    let deactivateDOT = false;
    if (vehicle.data.getVehicle.deactivateDOT !== undefined) {
      if (vehicle.data.getVehicle.deactivateDOT === true) deactivateDOT = true;
      else deactivateDOT = false;
    }
    //
    let regType = vehicle.data.getVehicle.customer.registeredInspectionType;
    if (regType === "FEDERAL") {
      this.setState({
        _dotDueDate: {
          value:
            [null, undefined].includes(insp) && insp.length <= 0
              ? ""
              : insp[0].nextDueDate,
          isValid: true,
          err: ""
        }
      });
    } else if (regType === "BIT") {
      this.setState({
        _bitDueDate90: {
          value:
            [null, undefined].includes(insp) && insp.length <= 0
              ? ""
              : insp[0].nextDueDate,
          isValid: true,
          err: ""
        }
      });
    } else if (regType === "FEDERAL_BIT") {
      this.setState({
        _dotDueDate: {
          value:
            [null, undefined].includes(insp) && insp.length <= 0
              ? ""
              : deactivateDOT
              ? ""
              : insp[0].nextDueDate,
          isValid: true,
          err: ""
        },
        _bitDueDate90: {
          value:
            [null, undefined].includes(insp) && insp.length <= 0
              ? ""
              : insp.length < 2
              ? deactivateDOT && !deactivateBIT
                ? insp[0].nextDueDate
                : ""
              : insp[1].nextDueDate,
          isValid: true,
          err: ""
        }
      });
    } else if (regType === "BUS_LIMOS") {
      this.setState({
        _bitDueDate45: {
          value:
            [null, undefined].includes(insp) && insp.length <= 0
              ? ""
              : insp[0].nextDueDate,
          isValid: true,
          err: ""
        }
      });
    }
    this.setState({
      typeName: {
        label: vehicle.data.getVehicle.vehicleType.vehicleType,
        value: vehicle.data.getVehicle.vehicleType.id
      },
      _typeName: {
        value: {
          label: vehicle.data.getVehicle.vehicleType.vehicleType,
          value: vehicle.data.getVehicle.vehicleType.id
        },
        isValid: true,
        err: ""
      },
      customerVehicleId: vehicle.data.getVehicle.customerVehicleId,
      _customerVehicleId: {
        value: vehicle.data.getVehicle.customerVehicleId,
        isValid: true,
        err: ""
      },
      Id: vehicle.data.getVehicle.id,
      license: vehicle.data.getVehicle.license,
      _license: {
        value: vehicle.data.getVehicle.license,
        isValid: true,
        err: ""
      },
      make: vehicle.data.getVehicle.make,
      _make: {
        value: vehicle.data.getVehicle.make,
        isValid: true,
        err: ""
      },
      model: vehicle.data.getVehicle.model,
      _model: {
        value: vehicle.data.getVehicle.model,
        isValid: true,
        err: ""
      },
      vehicleYear: vehicle.data.getVehicle.vehicleYear,
      _vehicleYear: {
        value: vehicle.data.getVehicle.vehicleYear,
        isValid: true,
        err: ""
      },
      vIN: vehicle.data.getVehicle.VIN,
      _vIN: {
        value: vehicle.data.getVehicle.VIN,
        isValid: true,
        err: ""
      },
      specialInstructions: vehicle.data.getVehicle.specialInstructions,
      vehicleStatus: vehicle.data.getVehicle.vehicleStatus,
      mainPic: vehicle.data.getVehicle.mainPic,
      vInPic: vehicle.data.getVehicle.vinPic,
      licensePic: vehicle.data.getVehicle.licensePic,
      deactivateBIT,
      deactivateDOT,
      registeredInspectionType: regType
    });
    await this.loadVehTypes();
    spinnerService.hide("mySpinner");
  };
  fetchFromStore = id => {
    const { registeredInspectionType } = this.state;
    this.props.data.customer.vehicles.items.map(Item => {
      if (Item.id === id) {
        var typeName = null;
        if (Item.vehicleType !== undefined && Item.vehicleType !== null) {
          typeName = {
            label: Item.vehicleType.vehicleType,
            value: Item.vehicleType.id
          };
        }
        let regType = Item.customer.registeredInspectionType;
        if (regType === "FEDERAL") {
          this.setState({
            dotDueDate: Item.nextInspectionDue[0].nextDueDate
          });
        } else if (regType === "BIT") {
          this.setState({
            bitDueDate90: Item.nextInspectionDue[0].nextDueDate
          });
        } else if (regType === "FEDERAL_BIT") {
          this.setState({
            dotDueDate: Item.nextInspectionDue[0].nextDueDate,
            bitDueDate90: Item.nextInspectionDue[1].nextDueDate
          });
        } else if (regType === "BUS_LIMOS") {
          this.setState({
            bitDueDate45: Item.nextInspectionDue[0].nextDueDate
          });
        }
        this.setState({
          typeName: typeName,
          customerVehicleId: Item.customerVehicleId,
          Id: Item.id,
          license: Item.license,
          make: Item.make,
          model: Item.model,
          updatedAt: "",
          vehicleYear: Item.vehicleYear,
          vIN: Item.VIN,
          specialInstructions: Item.specialInstructions,
          vehicleStatus: Item.vehicleStatus,
          registeredInspectionType: regType
        });
      }
    });
  };
  async componentDidMount() {
    // const { data } = this.props;

    // if (data.customer !== null || data.cutomer !== undefined) {
    //   this.setState({
    //     registeredInspectionType: data.customer.registeredInspectionType
    //   });
    // }
    await this.loadVehicle(this.props.match.params.vId);
  }
  handleChange = typeName => {
    this.setState({
      typeName,
      _typeName: {
        value: typeName,
        isValid: true,
        err: ""
      }
    });
    //
  };
  _onInputChange = event => {
    const { id, value } = event.target;
    if (id === "_vIN") {
      this.setState({
        [id]: {
          value: value.toUpperCase(),
          isValid: true,
          err: ""
        }
      });
    } else
      this.setState({
        [id]: {
          value,
          isValid: true,
          err: ""
        }
      });
  };
  handleVehicleImage = e => {
    let file = e.target.files[0];
    let { mainPic } = this.state;
    mainPic = file;
    this.setState({ mainPic });
  };
  handleVinImage = e => {
    let file = e.target.files[0];
    let { vInPic } = this.state;
    vInPic = file;
    this.setState({ vInPic });
  };

  handleLicenseImage = e => {
    let file = e.target.files[0];
    let { licensePic } = this.state;
    licensePic = file;
    this.setState({ licensePic });
  };
  uploadImage = async () => {
    let { mainPic, vInPic, licensePic } = this.state;
    if (mainPic && mainPic.name) {
      let key = await Storage.put(new Date().getTime() + mainPic.name, mainPic);
      mainPic = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
    }
    if (vInPic && vInPic.name) {
      let key = await Storage.put(new Date().getTime() + vInPic.name, vInPic);
      vInPic = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
    }
    if (licensePic && licensePic.name) {
      let key = await Storage.put(
        new Date().getTime() + licensePic.name,
        licensePic
      );
      licensePic = {
        bucket: "calbitwebappuploadbucket1254-dev",
        region: "us-east-2",
        key: key.key
      };
    }
    this.setState({ mainPic, licensePic, vInPic });
  };
  _onFocus = e => {
    e.currentTarget.type = "date";
  };
  _onBlur = (e, msg) => {
    e.currentTarget.type = "text";
    e.currentTarget.placeholder = msg;
  };
  render() {
    const { classes } = this.props;
    const {
      selectedOptions,
      open,
      mainPic,
      licensePic,
      vInPic,
      typeName,
      registeredInspectionType
    } = this.state;

    let inspectionDatesUI = <div></div>;
    if (registeredInspectionType === "FEDERAL") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">DOT Due Date *</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_dotDueDate"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateDOT}
                  // onBlur={!this.state.deactivateDOT && this.runtimeCheck}
                  onBlur={this.runtimeCheck}
                  placeholder="DOT Due Date"
                  value={this.state._dotDueDate.value}
                  required
                />
              </InputGroup>
              {/* <div style={{ fontSize: "smaller", marginTop: -15 }}>
                Your selected Inspection type is "Federal". If you want to
                change please go to Company Setup link.
              </div> */}
              {!this.state._dotDueDate.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._dotDueDate.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    } else if (registeredInspectionType === "BIT") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">BIT Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_bitDueDate90"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateBIT}
                  // onBlur={!this.state.deactivateBIT && this.runtimeCheck}
                  onBlur={this.runtimeCheck}
                  placeholder="BIT (90 Day) Due Date"
                  value={this.state._bitDueDate90.value}
                  required
                />
              </InputGroup>
              {!this.state._bitDueDate90.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._bitDueDate90.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    } else if (registeredInspectionType === "FEDERAL_BIT") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">DOT Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_dotDueDate"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateDOT}
                  // onBlur={!this.state.deactivateDOT && this.runtimeCheck}
                  onBlur={this.runtimeCheck}
                  placeholder="DOT Due Date"
                  value={this.state._dotDueDate.value}
                  required
                />
              </InputGroup>
              {!this.state._dotDueDate.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._dotDueDate.err}
                </text>
              )}
            </FormGroup>
          </Col>
          <Col>
            <FormGroup>
              <Label for="name">BIT Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  id="_bitDueDate90"
                  type="date"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateBIT}
                  // onBlur={!this.state.deactivateBIT && this.runtimeCheck}
                  onBlur={this.runtimeCheck}
                  placeholder="BIT (90 Day) Due Date"
                  value={this.state._bitDueDate90.value}
                  required
                />
              </InputGroup>
              {/* <div style={{ fontSize: "smaller", marginTop: -15 }}></div> */}
              {!this.state._bitDueDate90.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._bitDueDate90.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    } else if (registeredInspectionType === "BUS_LIMOS") {
      inspectionDatesUI = (
        <Row form>
          <Col>
            <FormGroup>
              <Label for="name">BIT 45Days Due Date</Label>
              <InputGroup className="input-group-alternative mb-3">
                <Input
                  style={{ marginLeft: 5 }}
                  id="_bitDueDate45"
                  type="text"
                  onChange={this._onInputChange}
                  disabled={this.state.deactivateBIT}
                  onBlur={this.runtimeCheck}
                  placeholder="BIT (45 Day) Due Date"
                  value={this.state._bitDueDate45.value}
                  required
                />
              </InputGroup>
              {!this.state._bitDueDate45.isValid && (
                <text
                  style={{
                    color: "red",
                    fontSize: 12,
                    marginLeft: 10
                  }}
                >
                  {" "}
                  {this.state._bitDueDate45.err}
                </text>
              )}
            </FormGroup>
          </Col>
        </Row>
      );
    }
    return (
      <div>
        <main ref="main" App>
          <Dialog
            open={open}
            onClose={() => this.setState({ open: false })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle
              id="alert-dialog-title"
              style={{
                width: 365,
                background: "linear-gradient(60deg, #ab47bc, #8e24aa)",
                color: "white"
              }}
            >
              {"Do you want to update"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-description"
                style={{ padding: 24, paddingBottom: 0, fontWeight: "bold" }}
                className="color-danger"
              >
                Are you sure!
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ open: false })}
                color="primary"
                className="bg-light text-dark"
              >
                Cancel
              </Button>
              <Button
                onClick={e => this.handleClose(e)}
                color="success"
                className="bg-success"
                autoFocus
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          <section className="section section-shaped section-lg">
            <Container className="pt-lg-sm pt-2">
              <Row className="justify-content-left">
                <Col lg={10}>
                  <Card>
                    <CardHeader color="primary">
                      <h4 className={classes.cardTitleWhite}>Edit Vehicle</h4>
                      <p className={classes.cardCategoryWhite}>Enter Details</p>
                    </CardHeader>
                    <CardBody>
                      <Form role="form">
                        <Row form>
                          <Col md={12}>
                            <FormGroup>
                              <Label for="name">Vehicle ID</Label>
                              <span style={{ margin: 10 }}>
                                ({" "}
                                {(!mainPic ||
                                  mainPic == {} ||
                                  (mainPic.key == undefined &&
                                    mainPic.name === undefined)) && (
                                  <div
                                    className="upload-btn-wrapper"
                                    style={{ marginBottom: -8 }}
                                  >
                                    <span>Add Vehicle Image</span>
                                    <input
                                      id="def-pic"
                                      type="file"
                                      name="myfile"
                                      onChange={e => this.handleVehicleImage(e)}
                                    />
                                  </div>
                                )}
                                {mainPic && mainPic.name && (
                                  <span>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {mainPic.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ mainPic: null })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                {mainPic && mainPic.key && (
                                  <span>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {mainPic.key.split(" ")[0]}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ mainPic: null })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                )
                              </span>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  autoFocus
                                  id="_customerVehicleId"
                                  // onChange={this.onInputChange}
                                  onChange={this._onInputChange}
                                  onBlur={this.runtimeCheck}
                                  placeholder="Vehicle ID"
                                  type="text"
                                  value={this.state._customerVehicleId.value}
                                  required
                                />
                              </InputGroup>
                              {!this.state._customerVehicleId.isValid && (
                                <text
                                  style={{
                                    color: "red",
                                    fontSize: 12,
                                    marginLeft: 10
                                  }}
                                >
                                  {" "}
                                  {this.state._customerVehicleId.err}
                                </text>
                              )}
                            </FormGroup>
                            <Input
                              id="Id"
                              onChange={this.onTextChange}
                              placeholder="CalBit ID"
                              type="hidden"
                              value={this.state.Id}
                              disabled
                              required
                            />
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="typeName">Vehicle Type</Label>
                              <Select
                                required
                                value={this.state.typeName}
                                onChange={this.handleChange}
                                onBlur={this.runtimeCheck}
                                id="typeName"
                                placeholder="Vehicle Type"
                                options={selectedOptions}
                              />
                              {!this.state._typeName.isValid && (
                                <text
                                  style={{
                                    color: "red",
                                    fontSize: 12,
                                    marginLeft: 10
                                  }}
                                >
                                  {" "}
                                  {this.state._typeName.err}
                                </text>
                              )}
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">V I N</Label>
                              <span style={{ margin: 10 }}>
                                (
                                {(!vInPic ||
                                  vInPic === {} ||
                                  (vInPic.key === undefined &&
                                    vInPic.name === undefined)) && (
                                  <span
                                    className="upload-btn-wrapper"
                                    style={{ marginBottom: -8 }}
                                  >
                                    <span>Add VIN Image</span>
                                    <input
                                      id="def-pic"
                                      type="file"
                                      name="myfile"
                                      onChange={e => this.handleVinImage(e)}
                                    />
                                  </span>
                                )}
                                {vInPic && vInPic.name && (
                                  <span>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {vInPic.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ vInPic: null })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                {vInPic && vInPic.key && (
                                  <span>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {vInPic.key.split(" ")[0]}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ vInPic: null })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                )
                              </span>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="_vIN"
                                  onChange={this._onInputChange}
                                  placeholder="V I N (17 Characters Long)"
                                  type="text"
                                  maxlength="17"
                                  minlength="17"
                                  onBlur={this.runtimeCheck}
                                  value={this.state._vIN.value}
                                  required
                                />
                              </InputGroup>
                              {!this.state._vIN.isValid && (
                                <text
                                  style={{
                                    color: "red",
                                    fontSize: 12,
                                    marginLeft: 10
                                  }}
                                >
                                  {" "}
                                  {this.state._vIN.err}
                                </text>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">Make</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="_make"
                                  onChange={this._onInputChange}
                                  placeholder="Make"
                                  type="text"
                                  value={this.state._make.value}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">Model</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  required
                                  id="_model"
                                  placeholder="Model"
                                  type="text"
                                  value={this.state._model.value}
                                  onChange={this._onInputChange}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row form>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">License</Label>
                              <span style={{ marginBottom: 10 }}>
                                (
                                {(!licensePic ||
                                  licensePic == {} ||
                                  (licensePic.key == undefined &&
                                    licensePic.name == undefined)) && (
                                  <span
                                    className="upload-btn-wrapper"
                                    style={{ marginBottom: -8 }}
                                  >
                                    <span>Add License Image</span>
                                    <input
                                      id="def-pic"
                                      type="file"
                                      name="myfile"
                                      onChange={e => this.handleLicenseImage(e)}
                                    />
                                  </span>
                                )}
                                {licensePic && licensePic.name && (
                                  <span style={{ marginBottom: -8 }}>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {licensePic.name}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ licensePic: null })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                {licensePic && licensePic.key && (
                                  <span style={{ marginBottom: -8 }}>
                                    <span
                                      className="badge badge-pill badge-primary"
                                      style={{ fontSize: 16 }}
                                    >
                                      {licensePic.key.split(" ")[0]}
                                      <span
                                        style={{ margin: 5, cursor: "pointer" }}
                                        onClick={() =>
                                          this.setState({ licensePic: null })
                                        }
                                      >
                                        {" "}
                                        X
                                      </span>
                                    </span>
                                  </span>
                                )}
                                )
                              </span>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="_license"
                                  onChange={this._onInputChange}
                                  placeholder="License"
                                  type="text"
                                  value={this.state._license.value}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label for="name">Year</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  required
                                  id="_vehicleYear"
                                  placeholder="Vehicle Year"
                                  type="text"
                                  onChange={this._onInputChange}
                                  value={this.state._vehicleYear.value}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row form>
                          <Col>
                            <FormGroup>
                              <Label for="name">Special Instruction</Label>
                              <InputGroup className="input-group-alternative mb-3">
                                <Input
                                  id="specialInstructions"
                                  onChange={this.onTextChange}
                                  placeholder="Special Instructions"
                                  type="text"
                                  value={this.state.specialInstructions}
                                  required
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        {inspectionDatesUI}
                        <Row>
                          <Col>
                            {" "}
                            {registeredInspectionType !== "FEDERAL" && (
                              <div style={{ float: "right" }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.deactivateBIT}
                                      onChange={e =>
                                        this.setState({
                                          deactivateBIT: e.target.checked,
                                          _bitDueDate90: {
                                            value: this.state._bitDueDate90
                                              .value,
                                            isValid: true,
                                            err: ""
                                          }
                                        })
                                      }
                                      inputProps={{
                                        "aria-label": "primary checkbox"
                                      }}
                                    />
                                  }
                                  label="Disable BIT"
                                />
                              </div>
                            )}
                            {registeredInspectionType !== "BIT" && (
                              <div style={{ float: "right" }}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={this.state.deactivateDOT}
                                      onChange={e =>
                                        this.setState({
                                          deactivateDOT: e.target.checked,
                                          _dotDueDate: {
                                            value: this.state._dotDueDate.value,
                                            isValid: true,
                                            err: ""
                                          }
                                        })
                                      }
                                      inputProps={{
                                        "aria-label": "primary checkbox"
                                      }}
                                    />
                                  }
                                  label="Disable DOT"
                                />
                              </div>
                            )}
                          </Col>
                        </Row>

                        <div className="text-center">
                          <Row lg="12" className="px-3 ">
                            <Col lg="2"></Col>
                            <Col>
                              <Button
                                className=" btn-lg btn-block mt-2"
                                color="primary"
                                type="button"
                                onClick={e => this.handleClickOpen(e)}
                              >
                                Submit
                              </Button>
                            </Col>
                            <Col>
                              <Button
                                className=" btn-lg btn-block mt-2"
                                color="default"
                                type="submit"
                                onClick={this.cancelForm}
                              >
                                Cancel
                              </Button>
                            </Col>
                            <Col lg="2"></Col>
                          </Row>
                        </div>
                      </Form>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </section>
        </main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    loading: state.vehicles.loading,
    data: state.vehicles.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // addCounter: (id) => dispatch({type:actionTypes.Add_Counter, val:id}),
    updateVehicle: data => {
      dispatch({ type: actionTypes.UPDATE_VEHICLE, data: data });
    }
  };
};
export default UpdateVehicle = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(UpdateVehicle));



// WEBPACK FOOTER //
// ./src/views/Company/UpdateVehicle.js